import request from '../utils/request';

export async function getExcel(id, shop) {
  return await request(`open/excelurl?id=${id}&shop=${shop}`, 'get');
}


